import { Injectable } from "@angular/core";
import { MemoryCache } from "../memory-cache-service";
import { WebApiClient } from "../web-api-client.service";
import { WebApiService } from "../web-api.service";

export class CompleteResult{
    Title:string;
    Content: string;
    Link:string;
} 

export class ImageDescriptionResult {
    Description: string;
    ResponseId: string;
}

@Injectable({providedIn:'root'})
export class AIChatAPI{
    apiService: WebApiService;
    constructor(private apiClient: WebApiClient,
        private memoryCache:MemoryCache) {
        this.apiService = this.apiClient.createHisService('system/AIChat');
        this.apiService.enableLoader = false;
    }
    async Complete(msg:string): Promise<CompleteResult[]>{
        var ret = await this.apiService.post('Complete',{Msg:msg}).toPromise<CompleteResult[]>();
        return ret
    }
    async CompleteNoPrompt(msg:string): Promise<CompleteResult[]>{
        var ret = await this.apiService.post('CompleteNoPrompt',{Msg:msg}).toPromise<CompleteResult[]>();
        return ret
    }
    async DescribeImage(image: File, templateType?: string, prompt?: string): Promise<ImageDescriptionResult>{
        if (!image) {
            throw new Error('請選擇圖片或PDF檔');
        }

        this.apiService.updateAuthData();
        const formData = new FormData();
        formData.append('image', image, image.name || 'upload');
        if (templateType) {
            formData.append('templateType', templateType);
        }
        if (prompt) {
            formData.append('prompt', prompt);
        }
        const headers = this.apiService.httpOptions.headers.delete('Content-Type');
        return await this.apiService.postAdv('DescribeImage', formData, true, { headers })
            .toPromise<ImageDescriptionResult>();
    }
    async FindParameter(msg:string): Promise<CompleteResult[]>{
        var ret = await this.apiService.post('FindParameter',{Msg:msg}).toPromise<CompleteResult[]>();
        return ret
    }
}
